<template>
  <div class="tool-tip">
    <div class="tool-tip-content">
      <div class="content-text">{{ content }}</div>
      <div :class="[directionClass]"></div>
      <!-- class="triangle" -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: 'Show Chart',
    },
    // 箭头方向 左-0 1-右 2-上 3-下
    direction: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    directionClass() {
      if (this.direction === 1) {
        return 'triangle-right';
      } else if (this.direction === 2) {
        return 'triangle-top';
      } else if (this.direction === 3) {
        return 'triangle-bottom';
      } else {
        return 'triangle-left';
      }
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.tool-tip {
  --triangle-width: 7px;
  --triangle-dis: -14px;
  .tool-tip-content {
    position: relative;
    padding: 5px 8px;
    background: var(--tooltip-bg);
    border-radius: 6px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
    .content-text {
      font-size: 12px;
      font-weight: 500;
      // color: var(--color-12);
      color: var(--tooltip-color);
    }
    .triangle-left {
      position: absolute;
      left: var(--triangle-dis);
      top: 50%;
      transform: translateY(-50%);
      width: var(--triangle-width);
      height: var(--triangle-width);
      border-top: var(--triangle-width) solid transparent;
      border-bottom: var(--triangle-width) solid transparent;
      border-left: var(--triangle-width) solid transparent;
      border-right: var(--triangle-width) solid var(--border-1);
    }
    .triangle-right {
      position: absolute;
      right: var(--triangle-dis);
      top: 50%;
      transform: translateY(-50%);
      width: var(--triangle-width);
      height: var(--triangle-width);
      border-top: var(--triangle-width) solid transparent;
      border-bottom: var(--triangle-width) solid transparent;
      border-right: var(--triangle-width) solid transparent;
      border-left: var(--triangle-width) solid var(--border-1);
    }
    .triangle-top {
      position: absolute;
      left: 50%;
      top: var(--triangle-dis);
      transform: translateX(-50%);
      width: var(--triangle-width);
      height: var(--triangle-width);
      border-top: var(--triangle-width) solid transparent;
      border-left: var(--triangle-width) solid transparent;
      border-right: var(--triangle-width) solid transparent;
      border-bottom: var(--triangle-width) solid var(--border-1);
    }
    .triangle-bottom {
      position: absolute;
      left: 50%;
      bottom: var(--triangle-dis);
      transform: translateX(-50%);
      width: var(--triangle-width);
      height: var(--triangle-width);
      border-bottom: var(--triangle-width) solid transparent;
      border-left: var(--triangle-width) solid transparent;
      border-right: var(--triangle-width) solid transparent;
      border-top: var(--triangle-width) solid var(--border-1);
    }
  }
}

@media screen and (max-width: 767px) {
  .tool-tip {
    --triangle-width: 7px;
    --triangle-dis: -14px;
  }
}
</style>
